<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="container mt-4">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <a href="#home" data-bs-toggle="tab" aria-expanded="false" class="nav-link active" aria-selected="false"
                tabindex="-1" role="tab">
               <i class="fas fa-book-open"></i>  <span class="d-inline-block d-sm-none">Homework</span>
                 <span class="d-none d-sm-inline-block"> Homework</span>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a href="#group" data-bs-toggle="tab" aria-expanded="true" class="nav-link" aria-selected="true"
                role="tab">
                <i class="fas fa-users-line me-1"></i><span class="d-inline-block d-sm-none ms-1"> Group Homework</span>
                <span class="d-none d-sm-inline-block"> Group Homework</span>
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane show active" id="home" role="tabpanel">
              <div class="row">
                <div class="col-12">
                  <div class=" d-flex align-items-center">
                    <h5 class="mb-0 text-primary"><i class="fa fa-book text-primary"></i> Home Work</h5>
                  </div>
                  <hr>
                  <div class="row g-3">
                    <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
                    <div class=" col-md-3">
                      <label for="inputclassname" class="form-label">Section<sup><span
                            class="text-danger font-12">*</span></sup> :</label>
                      <select class="form-select form-select-sm rounded cursor-pointer" role="button" id="inputclass" v-model="Obj.sectionID">
                        <option selected=""></option>
                        <option v-for="(item, index) in secList" :key="index" :value="item._id">
                          {{ item.Name }}
                        </option>
                      </select>
                    </div>
                    <div class=" col-md-3">
                      <label class="form-label">Day<sup><span class="text-danger font-12">*</span></sup> :</label>
                     <input type="text" class="form-control form-control-sm" v-model="Obj.day" readonly />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Date<sup><span
                            class="text-danger font-12">*</span></sup> :</label>
                      <input class="form-control form-control-sm" type="date" v-model="Obj.HWDate" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Reading Work :</label>
                      <input class="form-control form-control-sm" type="text" v-model="Obj.ReadWork"/>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Writing/Practice Work :</label>
                      <input class="form-control form-control-sm" type="text" v-model="Obj.WriteWork"/>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">New Word :</label>
                      <input class="form-control form-control-sm" type="text" v-model="Obj.NewWords"/>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Teacher Remarks :</label>
                      <input class="form-control form-control-sm" type="text" v-model="Obj.Remarks"/>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">File :</label>
                      <label for="fileInput" class="attachment-icon">
                        <i class="fa fa-upload"></i>
                      </label>
                     <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
                    <div class="d-flex align-items-start">
                    <a v-if="Obj.Image" :href="Obj.Image ? getUrl(Obj.Image) : ''" target="_blank">
                    {{ Obj.Image && typeof Obj.Image === 'string' ? Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1) : '' }} </a>
                        <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
                    </div></div>
                    <div class="col-md-12" v-for="(subject, index) in SavedSubjects" :key="'saved-' + index">
                      <div class="row align-items-end">
                        <div class="col-md-3">
                          <label class="form-label">Subject :</label>
                          <div class="border-a">
                            {{subList.find(s => s._id === subject.subID)?.name || subject.subID}}
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Description :</label>
                          <div class="border-a"> {{ subject.Description }} </div>
                        </div>
                        <div class="col-md-3 d-flex gap-2">
                          <i class="fa fa-times-circle text-danger fa-2x cursor-pointer-a" role="button" @click="rmvSub(index)"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9"></div>
                    <div class="col-md-12">
                      <div class="row align-items-end" v-for="(item, index) in dynSubs" :key="index">
                        <div class="col-md-3">
                          <select class="form-select form-select-sm rounded mb-2 mb-md-0 cursor-pointer" role="button" v-model="item.subID">
                            <option value="" disabled>Select Subject</option>
                            <option v-for="sub in getSubs()" :key="sub._id" :value="sub._id">
                              {{ sub.name }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <input class="form-control form-control-sm" v-model="item.Description"
                            placeholder="Description" />
                        </div>
                        <div class="col-md-3 d-flex align-items-center gap-2">
                          <i class="fa fa-times-circle text-danger fa-2x cursor-pointer mt-2" role="button" v-if="dynSubs.length > 1"
                            @click="rmvSub(index)"></i>
                          <i class="fa fa-plus-circle text-success fa-2x mt-2 cursor-pointer" role="button"
                            v-if="index === dynSubs.length - 1" @click="addSub"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 text-end">
                      <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i
                          class="fa fa-save"></i> Save</button>
                      <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i
                          class="fa fa-times-circle  me-1"></i> Cancel</button>
                    </div>
                  </div>
                  <ul v-if="Object.keys(errors).length" class="text-danger ps-3">
                    <li v-for="(err, key) in errors" :key="key">{{ err }}</li>
                  </ul>
                  <div class="row mt-3">
                    <div class="col-sm-12 table-responsive">
                       <div class="progress mb-0 progress-sm" v-if="progress!=0">
                    <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                      :style="{ width: progress + '%' }"></div>
                  </div>
                      <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"
                        :actions="{ delete: handleDelete }" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="group" role="tabpanel">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-2 col-12 p-0">
                    <div class="nav flex-column nav-pills nav-pills-tab" id="v-pills-tab" role="tablist"
                      aria-orientation="vertical">
                      <a class="nav-link active show mb-1 me-1" id="v-pills-home-tab" data-bs-toggle="pill"
                        href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">
                        All</a>
                      <div v-for="(cls, index) in uniqueClsList" :key="cls._id">
                        <a class="nav-link mb-1 text-dark" data-bs-toggle="pill" h :href="'#class' + index" role="tab"
                          :id="'class' + index + '-tab'" aria-controls="v-pills-profile" aria-selected="false"
                          tabindex="-1">
                          {{ cls.name }}</a>
                      </div>
                    </div>
                  </div> 
                  <div class="col-md-10 col-12 p-0">
                    <div class="tab-content pt-0">
                      <div class="tab-pane fade active show" id="v-pills-home" role="tabpanel"
                        aria-labelledby="v-pills-home-tab">
                        <div class="content-frame text-start ">
                          <p v-if="!homeworkList || Object.keys(homeworkList).length === 0" class="text-muted">
                             No homework available.... </p>
                          <div v-for="(clsObj, clsID) in homeworkList" :key="clsID">
                         <div v-for="(entry, groupKey) in clsObj" :key="groupKey" >
                           <span v-html="entry.htmlContent" class="text-black"></span>
                           <span v-if="!entry.Image">
                           <div class="card w-100 mb-3 container-fluid card-f p-0">
                          <div class="card-body border border-black rounded p-0 container-a">
                            <div class="d-flex justify-content-between ms-2 me-2 mt-1 flex-wrap">
                              <span><strong>Day:</strong> {{ entry.day }}</span>
                              <span><strong>Class:</strong> {{ entry.className }}</span>
                              <span><strong>Date:</strong> {{ entry.date }}</span>
                            </div>
                            <div class="table-responsive text-nowrap">
                            <table class="table table-bordered mb-0 custom-table">
                              <tbody>
                                <tr v-if="entry.ReadWork"> <td style="width:26%;"><strong>Reading Work</strong></td> <td>{{ entry.ReadWork }}</td> </tr>
                                <tr v-for="(subj, sIdx) in entry.subjectsTable" :key="sIdx"> <td><strong> {{ subj.name }}</strong></td> <td>{{ subj.desc }}</td> </tr>
                                <tr v-if="entry.WriteWork"> <td><strong>Writing/Practice Work</strong></td> <td>{{ entry.WriteWork }}</td> </tr>
                                <tr v-if="entry.NewWords"> <td><strong>New Word</strong></td> <td>{{ entry.NewWords }}</td> </tr>
                                <tr v-if="entry.Remarks"> <td><strong>Teacher Remarks</strong></td> <td>{{ entry.Remarks }}</td> </tr>
                              </tbody>
                            </table>
                            </div>
                            <div class="table-responsive">
                            <table class="table table-bordered text-center custom-table mb-0">
                              <thead>
                                <tr>
                                  <td><strong>Class Teacher Initial</strong></td>
                                  <td class="p-0 w-50">
                                    <table class="table table-bordered mb-0 text-start mt-69">
                                      <tbody>
                                        <tr> <td class="w-365"><strong>GkQuestion</strong></td> <td class="w-100"> </td> </tr>
                                        <tr> <td><strong>Answer</strong></td> <td></td> </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td><strong>Parent Signature</strong></td>
                                </tr>
                              </thead>
                            </table></div>
                        </div>
                        </div>
                        </span>
                        </div>
                        </div>
                        </div>
                      </div>
                      <div v-for="(cls, index) in uniqueClsList" :id="'class' + index"
                        :aria-labelledby="'class' + index + '-tab'" :key="cls._id" class="tab-pane fade"
                        role="tabpanel">
                        <div class="content-frame">
                          <p v-if="!classwiseHomework[cls._id] || Object.keys(classwiseHomework[cls._id]).length === 0" class="text-black">
                             No homework available.... </p>
                         <div v-for="(entry, groupKey) in classwiseHomework[cls._id]" :key="groupKey" >
                           <span v-html="entry.htmlContent" class="text-black"></span>
                           <span v-if="!entry.Image">
                           <div class="card w-100 mb-3 container-fluid card-f p-0">
                          <div class="card-body border border-black rounded p-0 container-a">
                            <div class="d-flex justify-content-between ms-2 me-2 mt-1 flex-wrap">
                              <span><strong>Day:</strong> {{ entry.day }}</span>
                              <span><strong>Class:</strong> {{ entry.className }}</span>
                              <span><strong>Date:</strong> {{ entry.date }}</span>
                            </div>
                          <div class="table-responsive">

                            <table class="table table-bordered mb-0 custom-table text-nowrap">
                              <tbody>
                                <tr v-if="entry.ReadWork"> <td style="width:26%;"><strong>Reading Work</strong></td> <td>{{ entry.ReadWork }}</td> </tr>
                                <tr v-for="(subj, sIdx) in entry.subjectsTable" :key="sIdx"> <td><strong> {{ subj.name }}</strong></td> <td>{{ subj.desc }}</td> </tr>
                                <tr v-if="entry.WriteWork"> <td><strong>Writing/Practice Work</strong></td> <td>{{ entry.WriteWork }}</td> </tr>
                                <tr v-if="entry.NewWords"> <td><strong>New Word</strong></td> <td>{{ entry.NewWords }}</td> </tr>
                                <tr v-if="entry.Remarks"> <td><strong>Teacher Remarks</strong></td> <td>{{ entry.Remarks }}</td> </tr>
                              </tbody>
                            </table>
                          </div>
                            <div class="table-responsive">
                            <table class="table table-bordered text-center custom-table mb-0">
                              <thead>
                                <tr>
                                  <td><strong>Class Teacher Initial</strong></td>
                                  <td class="p-0 w-50">
                                    <table class="table table-bordered mb-0 text-start mt-69">
                                      <tbody>
                                        <tr> <td class="w-365"><strong>GkQuestion</strong></td> <td class="w-100"> </td> </tr>
                                        <tr> <td><strong>Answer</strong></td> <td></td> </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td><strong>Parent Signature</strong></td>
                                </tr>
                              </thead>
                            </table></div>
                        </div>
                        </div>
                        </span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
  <DelPopup :name="clsList.find(cls => cls._id == delObj.clsID)?.name || ''" @delRecord="delRecord" @closeModal="delObj.clsID = ''"> </DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadImg } = useFileUpload();
import { formatDate, api } from '@/utils/helpers.js';
import { ref, onMounted, computed, watch } from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList,  subList } = schoolStore();
const Obj = ref({
  clsID: "", sectionID: "", day: "", ReadWork: "", WriteWork: "", NewWords: "",Remarks: "", HWDate: new Date().toISOString().slice(0, 10), Image: '',
  Subjects: [{ subID: "", Description: "", }],
})
const SavedSubjects = ref([])
const msgObj = ref({ msg: "", role: "", show: false, })
const delObj = ref({})
const errors = ref({})
const homeworkList = ref({});
const classwiseHomework = ref({});
const cols = ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Class', key: 'class' },
  { label: 'Description', key: 'SubDescription',truncatable: true },
  { label: 'Date', key: 'DateHW' },
  { label: 'Day', key: 'Day' },
  { label: 'Image', key: 'Image', type: "image" },
]);
const dynSubs = ref([
  { subID: '', Description: '' }
])
const addSub = () => {
  dynSubs.value.push({ subID: '', Description: '' })
}
const rmvSub = (index) => {
  if (dynSubs.value.length > 1) {
    dynSubs.value.splice(index, 1)
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows = ref([])
const filteredSubjects = computed(() => {
  if (!Obj.value.clsID) return [];
  return subList.value.filter(s => s.clsID === Obj.value.clsID);
});
const getSubs = () => {
  return filteredSubjects.value;
};
 const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
  event.target.value = null;
};
watch(() => Obj.value.HWDate, (newDate) => {
  if (!newDate) return;
  const days = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
  Obj.value.day = days[new Date(newDate).getDay()];
});

const save = async () => {
  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired], },
    Section: { value: Obj.value.sectionID, validators: [isRequired], },
    Day: { value: Obj.value.day, validators: [isRequired], },
  };
  errors.value = {
    ...validateForm(fields)
  };
  dynSubs.value = dynSubs.value.filter(
    item => Object.values(item).some(val => val && String(val).trim() !== '')
  );
  if (Object.keys(errors.value).length === 0) {
   for (const subject of dynSubs.value) {
  subject.clsID = Obj.value.clsID;
  subject.sectionID = Obj.value.sectionID;
  subject.day = Obj.value.day;
  subject.HWDate = Obj.value.HWDate;
  subject.ReadWork = Obj.value.ReadWork;
  subject.WriteWork = Obj.value.WriteWork;
  subject.NewWords = Obj.value.NewWords;
  subject.Remarks = Obj.value.Remarks;
  subject.Image = Obj.value.Image;
  if (!subject.subID) delete subject.subID;
  if (!subject.Description) delete subject.Description;
  await api.post(`/homework/add`, subject)
    .then(() =>   {
          msgObj.value = { msg: "Home Work Added Successfully", role: "success", show: true };
        })
    .catch((error) => console.log(error));
}
if(Obj.value.Image && dynSubs.value.length ==0 && Object.keys(errors.value).length === 0){
  let subject = {};
subject.clsID = Obj.value.clsID;
  subject.sectionID = Obj.value.sectionID;
  subject.day = Obj.value.day;
  subject.HWDate = Obj.value.HWDate;
  subject.ReadWork = Obj.value.ReadWork;
  subject.WriteWork = Obj.value.WriteWork;
  subject.NewWords = Obj.value.NewWords;
  subject.Remarks = Obj.value.Remarks;
  subject.Image = Obj.value.Image;
  await api.post(`/homework/add`, subject)
    .then(() => {
          msgObj.value = { msg: "Home Work Added Successfully", role: "success", show: true };
        })
    .catch((error) => console.log(error));
}
    loadData(); reset();
  }
}
const reset = async () => {
  Obj.value = { ExamType: "", clsID: "", sectionID: "", Image: "", HWDate: new Date().toISOString().slice(0, 10), ReadWork: "", WriteWork: "", NewWords: "", Remarks: "", Subjects: [{ subID: "", Description: "", },], };
 
  errors.value = {};
  dynSubs.value = [ { subID: '', Description: '' } ];
}
 const progress = ref(0)
const loadData = async () => {
      let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
  await api.get('/homework/all').then((response) => {
    rows.value = response.data.map((item, i) => ({
      ...item, Sno: i + 1, Image: item.Image || '', Day: item.day, DateHW: formatDate(item.HWDate),
      SubDescription: Array.isArray(item.subject) && item.subject.length > 0
        ? item.subject
          .filter(({ subID, Description }) => subID || Description)
          .map(({ subID, Description }) => {
            const subName = subList.value.find(sub => sub._id === subID)?.name || '';
            const Desc = Description || '';
            return `${subName}: ${Desc}`;
          }) .join(', ') || '' : '',
    subjectsTable: Array.isArray(item.subject) ? item.subject.map(s => {
  const subName = subList.value.find(sub => sub._id === s.subID)?.name || s.subID || 'Subject';
  return { name: subName, desc: s.Description };
}) : [],
      class: `${clsList.value.find(cls => cls._id === item.clsID)?.name || ''} (${secList.value.find(sec => sec._id === item.sectionID)?.Name || ''})`
    }));
rows.value.forEach(item => {
  const clsID = item.clsID;
  const secID = item.sectionID;
  const dateKey = item.HWDate;
  const groupKey = `${clsID}_${secID}_${dateKey}`;
  const className = clsList.value.find(cls => cls._id === item.clsID)?.name || '';
  const sectionName = secList.value.find(sec => sec._id === item.sectionID)?.Name || '';
  const allImage = item.Image
    ? `<br><img src="${getUrl(item.Image)}"  class="img-thumbnail w-50 h-50 cursor-pointer" role="button"/><br>`
    : '';
  if (!homeworkList.value[clsID]) homeworkList.value[clsID] = {};
  if (!homeworkList.value[clsID][groupKey]) {
    homeworkList.value[clsID][groupKey] = {
      className: `${className} (${sectionName})`,
      date: formatDate(item.HWDate),
      day: item.Day,
      ReadWork: item.ReadWork,
      WriteWork: item.WriteWork,
      NewWords: item.NewWords,
      Remarks: item.Remarks,
      Image: item.Image,
      subjectsTable: [],
      htmlContent: `${className} (${sectionName}) : ${allImage}<br/>`
    };
  }

  const subjects = Array.isArray(item.subject)
    ? item.subject
        .filter(s => s.subID || s.Description)
        .map(s => {
          const subName = subList.value.find(sub => sub._id === s.subID)?.name || s.subID || 'Subject';
          return { name: subName, desc: s.Description };
        })
    : [];
  homeworkList.value[clsID][groupKey].subjectsTable.push(...subjects);
  if (!classwiseHomework.value[clsID]) classwiseHomework.value[clsID] = {};
  if (!classwiseHomework.value[clsID][groupKey]) {
    classwiseHomework.value[clsID][groupKey] = {
      className: `${className} (${sectionName})`,
      date: formatDate(item.HWDate),
      day: item.Day,
      ReadWork: item.ReadWork,
      WriteWork: item.WriteWork,
      NewWords: item.NewWords,
      Remarks: item.Remarks,
      Image: item.Image,
      subjectsTable: [],
      htmlContent: `${className} (${sectionName}) : ${allImage}<br/>`
    };
  }
  classwiseHomework.value[clsID][groupKey].subjectsTable.push(...subjects);
});

  progress.value = 0
  clearInterval(progressInterval)
  });
};
 const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
const delRecord = async () => {
  await api.delete(`/homework/${delObj.value._id}`)
    .then(() => {
      loadData();
      delObj.value = {};
      msgObj.value = { msg: "Homework Deleted Successfully.", role: "danger", show: true };
    });
}
const getUrl = (img) => {
  if (!img || typeof img !== "string") { return ""; }
  const imgUrl = img.startsWith("..") ? img.substring(2) : img;
   return  process.env.VUE_APP_API_URL + imgUrl;
};

onMounted(() => { loadData();
   const days = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
  Obj.value.day = days[new Date(Obj.value.HWDate).getDay()];
 })
</script>
<style>
.nav-link-a.active {
  background-color: #d3d3d3 !important;
  color: white !important;
}

.nav-link.active {
  background-color: #d3d3d3 !important;
  color: white !important;
}

.nav-link {
  color: black !important;
}

.nav-link-a {
  color: black !important;
}
.content-frame {
  border: 1px solid #242a5f;
 border-radius: 15px;
  padding: 20px;
  background-color: white;
  min-height:30rem;
  margin-left: -12px;
  margin-right:-12px;
  margin-top: -10px;
  margin-bottom: -20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.img-hover-container {
  position: relative;
  display: inline-block;
}

.img-preview-a {
  display: none;
  position: absolute;
  top: -65px;
  left: 105%;
  z-index: 10;
  background-color: white;
  padding: 0px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  width: 0%;
  bottom: 0px;
}

.img-hover-container:hover .img-preview-a {
  display: block;
}

.img-preview-a img {
  max-width: 200px;
  max-height: 140px;
  object-fit: fill;
}
.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}
.nav-stacked>li+li {
    margin-top: 2px;
    margin-left: 0;
    margin-right: -35px;
}
.nav-pills>li.active>a, .nav-pills>li.active>a:focus, .nav-pills>li.active>a:hover {
    color: #fff;
    background-color: #d3d3d3;
}
.nav-stacked>li {
    float: none;
    margin-right: -30px;
}
#fileInput {
    display: none;
}
.attachment-icon {
    cursor: pointer;
    font-size: 20px;
    color: #333;
    padding: 5px;
    display: inline-block;
}
.nav-tabs .nav-link.active {
  color: #fff !important; 
  background-color: #242a5f !important; 
  border-color: #dee2e6 #dee2e6 #fff !important;
}
.custom-table th,
.custom-table td {
  padding: 3px 5px;
}
.nav-tabs {
  flex-wrap: wrap;          
  overflow-x: visible;
}
@media (max-width: 575.98px) {
    .nav-tabs {
    display: flex;
  } 
  .nav-tabs .nav-item {
    flex: 1;
    text-align: center;
  }
  .nav-tabs {
    flex-wrap: nowrap;       
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .nav-tabs .nav-item {
    flex: 0 0 auto;
  }
   .nav-pills.nav-pills-tab {
    flex-direction: row !important;    
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    gap: 5px;
    padding-bottom: 5px;
  }

  .nav-pills.nav-pills-tab .nav-link {
    flex: 0 0 auto;                  
    text-align: center;
    font-size: 12px;
    padding: 0.25rem 0.5rem;
    white-space: nowrap;               
  }
  .nav-pills.nav-pills-tab .nav-link.active {
    border-radius: 5px 5px 0px 0px;
  }
}
.nav-pills.nav-pills-tab {
  flex-direction: column;   
  overflow-x: auto !important;
  flex-wrap: nowrap !important;
}
.nav-pills.nav-pills-tab .nav-link {
  border-radius: 0;
  color: black !important;
  text-align: left;
}
.nav-pills.nav-pills-tab .nav-link.active {
   background-color: #242a5f !important;
  color: white !important;
  border-radius: 5px 0px 0px 5px;
}
@media (max-width: 767px) {
  .content-frame {
  margin-left: 0px !important;
}
.card-f {
  overflow-x: auto;
}
.container-a {
  min-width: 560px;
}
}
</style>